export default __webpack_public_path__ + "media/icons/close-white-94791be7.svg";